import { render, staticRenderFns } from "./iconCalendar.vue?vue&type=template&id=f05f9a8c&scoped=true"
import script from "./iconCalendar.vue?vue&type=script&lang=js"
export * from "./iconCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f05f9a8c",
  null
  
)

export default component.exports